"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VXContract = exports.VXContractReveserveResult = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const IVXABI_1 = require("./abi/IVXABI");
class VXContractReveserveResult {
}
exports.VXContractReveserveResult = VXContractReveserveResult;
class VXContract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, IVXABI_1.IVXABI.GetABI());
    }
    stakeAsync(valueEth, withPost = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const valueWEI = this._toWei(valueEth);
            const result = yield this._pay(valueWEI, "stake", withPost);
            return result;
        });
    }
    unstakeAsync(valueVX, withPost = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const valueVXWEI = this._toWei(valueVX);
            const result = yield this._send("unstake", valueVXWEI, withPost);
            return result;
        });
    }
    withdraw(valueEth, forAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const valueWEI = this._toWei(valueEth);
            const result = yield this._send("withdraw", valueWEI, forAddress);
            return result;
        });
    }
    getWithdrawalAsync(forAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const withdrawal = yield this._call("getWithdrawal", forAddress);
            return this._toDecimal(withdrawal);
        });
    }
    getTotalWithdrawalValueAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const withdrawal = yield this._call("totalWithdrawalValue");
            return this._toDecimal(withdrawal);
        });
    }
    getReserveOfAsync(forAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._call("reserveOf", forAddress);
            if (!result)
                return;
            result.value = this._toDecimal(result.value);
            return result;
        });
    }
    withdrawReserveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this._send("withdrawReserve");
            return result;
        });
    }
}
exports.VXContract = VXContract;
//# sourceMappingURL=VXContract.js.map